export const getANPHost = () => {
  // eslint-disable-next-line no-restricted-globals
  const host = location.hostname;
  return host === "factors.analyticalplatform.com"
    ? "https://app.analyticalplatform.com"
    : "https://test.analyticalplatform.com";
};
